var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnounce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8845 5C20.4621 5 20.9371 5.43372 20.9942 5.98951L21 6.1022V17.8975C21 18.0116 20.9821 18.125 20.9468 18.2337C20.7715 18.7748 20.2127 19.0891 19.662 18.9777L19.5442 18.9472L13.4544 17.0208C12.8048 18.1437 11.5852 18.8718 10.2252 18.8718C8.23377 18.8718 6.60799 17.3251 6.51129 15.3812L6.50674 15.1978L6.50648 14.8206L5.77952 14.5913V9.53917L19.535 5.05549C19.6478 5.01873 19.7657 5 19.8845 5ZM8.37878 15.4148C8.48743 16.3271 9.27265 17.0348 10.2252 17.0348C10.7632 17.0348 11.2574 16.8069 11.6012 16.4338L8.37878 15.4148ZM19.1401 7.11866L7.63807 10.868V13.2506L19.1401 16.8906V7.11866ZM4.84593 9.54918V14.5713L4.36549 14.5469C3.63831 14.4739 3.07037 13.8987 3.00607 13.1872L3 13.0522V11.0516C3 10.2655 3.61101 9.62042 4.38937 9.55469L4.52057 9.54918H4.84593Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnounce);
export default __webpack_public_path__ + "static/media/Announce.c42dabb7.svg";
export { ForwardRef as ReactComponent };